import Printjs from 'print-js'
import { Message } from "element-ui";
import { MessageBox } from 'element-ui';
export default ({ request }) => ({
  // 导出公共方法
  globalExportData(url, params, fileName) {
    let newData = getNowFormatDateFun();
    fileName = fileName + newData;
    let suffix = ".xlsx";
    this.axiosFile(url, params, (r) => {
      const content = r;
      let responseType = r.type;
      const blob = new Blob([content], {
        type: responseType,
      });
      console.log(r);
      if (r.type === "application/pdf") {
        suffix = ".pdf";
      }
      if (
        r.type !== "application/pdf" &&
        r.type !== "application/vnd.ms-excel" &&
        r.type !== "text/xml" &&
        r.type !== "application/octet-stream"
      ) {
        let reader = new FileReader();
        reader.readAsText(blob, "utf-8");
        reader.onload = function (e) {
          let resultJson = JSON.parse(reader.result);
          console.log(resultJson.msg);
          Message({
            message: resultJson.msg,
            type: "error",
            duration: 5 * 1000,
          });
        };
        return;
      }
      fileName = fileName + suffix;
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    });
  },
  // POST输出文件流
  axiosFile(url, data, success) {
    request({
      method: "post",
      url: url,
      data: data,
      responseType: "blob",
    }).then(function (res) {
      success(res);
    });
  },
  // 调用打印窗口，预览PDF
  printPDF(url, data) {
    if (/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) {
      MessageBox.alert('当前浏览器不支持打印，请尝试更换其它浏览器！', '提示', {
        type: 'info'
      })
      return
    }
    this.axiosFile(url, data, (r) => {
      const content = r
      let responseType = r.type
      const blob = new Blob([content], {
        type: responseType,
      })
      Printjs({
        printable: URL.createObjectURL(blob),
        type: 'pdf',
        showModal: true,
      })
    })
  },
});
function getNowFormatDateFun() {
  let date = new Date();
  let seperator1 = "";
  let seperator2 = "";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  let minutes = date.getMinutes();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if (minutes >= 0 && minutes <= 9) {
    minutes = "0" + minutes;
  }
  let currentdate =
    date.getFullYear() +
    seperator1 +
    month +
    seperator1 +
    strDate +
    "" +
    date.getHours() +
    seperator2 +
    minutes +
    seperator2 +
    date.getSeconds();
  return currentdate;
}
